import { EanEligibilityStatusEnum } from '../enum/EanEligibilityStatusEnum';
export namespace EanUtils {
  export function isValidGTIN(ean: string) {
    const checkDigit =
      (String(ean)
        .slice(0, -1)
        .split('')
        .reverse()
        .reduce((sum, v, i) => sum + +v * (i % 2 || 3), 0) *
        9) %
      10;
    return /^\d+$/.test(ean) && String(checkDigit) === String(ean).at(-1);
  }

  export function isEligibilityError(status?: number) {
    return status === 409 || status === 417;
  }

  export function getEanEligibilityStatus(code: number) {
    switch (code) {
      case 417:
        return EanEligibilityStatusEnum.DeleteRequest;
      case 1001:
        return EanEligibilityStatusEnum.AskConsent;
      case 1002:
        return EanEligibilityStatusEnum.ContractNotRegisteredWithEmail;
      case 1000:
        return EanEligibilityStatusEnum.Success;
      case 3001:
        return EanEligibilityStatusEnum.ContractNotFound;
      case 409:
      case 1003:
        return EanEligibilityStatusEnum.Conflict;
      case 2003:
        return EanEligibilityStatusEnum.NotYearlyMetering;
      case 2002:
        return EanEligibilityStatusEnum.NoActiveDevice;
      case 9001:
        return EanEligibilityStatusEnum.ConflictRequest;
      case 4001:
      case 4002:
        return EanEligibilityStatusEnum.Existing;
      default:
        return EanEligibilityStatusEnum.Invalid;
    }
  }

  export function getEanEligibilityStatusError(status: EanEligibilityStatusEnum) {
    switch (status) {
      case EanEligibilityStatusEnum.Conflict:
        return 'meter.ean.conflict.error';
      case EanEligibilityStatusEnum.Invalid:
        return 'meter.ean.not.eligible.error';
      case EanEligibilityStatusEnum.ContractNotFound:
        return 'meter.ean.contract.not.found.error';
      case EanEligibilityStatusEnum.ContractNotRegisteredWithEmail:
        return 'meter.ean.contract.not.register.with.email.error';
      case EanEligibilityStatusEnum.DeleteRequest:
        return 'meter.ean.contract.delete.request.error';
      case EanEligibilityStatusEnum.ConflictRequest:
        return 'meter.ean.conflict.request.error';
      case EanEligibilityStatusEnum.NotYearlyMetering:
        return 'meter.ean.no.yearly.metering.error';
      case EanEligibilityStatusEnum.NoActiveDevice:
        return 'meter.ean.no.active.device.error';
      default:
        return 'meter.ean.error';
    }
  }
}

export class EanURLTool {
  private SECRET_KEY: string;
  constructor() {
    const part1 = 'my';
    const part2 = String.fromCharCode(95, 115, 101, 99, 114, 101, 116);
    this.SECRET_KEY = part1 + part2;
  }

  private xorCipher(text: string, key: string) {
    let result = '';
    for (let i = 0; i < text.length; i++) {
      const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      result += String.fromCharCode(charCode);
    }
    return result;
  }
  encrypt(ean: string) {
    if (!ean) return null;
    const ciphered = this.xorCipher(ean, this.SECRET_KEY);
    let hex = '';
    for (let i = 0; i < ciphered.length; i++) {
      hex += ciphered.charCodeAt(i).toString(16).padStart(2, '0');
    }
    return hex;
  }

  decrypt(encryptedEan: string) {
    if (!encryptedEan) return null;
    let str = '';
    for (let i = 0; i < encryptedEan.length; i += 2) {
      str += String.fromCharCode(parseInt(encryptedEan.substr(i, 2), 16));
    }
    return this.xorCipher(str, this.SECRET_KEY);
  }
}

export const EanURL = new EanURLTool();
